import { FC, PropsWithChildren, ReactElement } from "react";
import { useRecoilValue } from "recoil";

import { FilterSearch } from "@ryde/controls";
import { useReportsContext } from "@ryde/redux";
import { reportFiltersWithValuesAF } from "@ryde/shared";

import {
  FilterMultiSelectReports,
  FiltersActionsReport,
  FiltersByIdsReport,
  useReportFilterSearch,
} from "../filters";

const APPLY_SEARCH_TIMEOUT = 100;

interface IPageHeaderFilters extends PropsWithChildren {
  isServerSearch?: boolean;
  Actions?: ReactElement;
}

export const PageHeaderFiltersReport: FC<IPageHeaderFilters> = ({
  Actions = <FiltersActionsReport />,
}) => {
  const { reportDto, reportId } = useReportsContext();
  const templateFilters = reportDto?.reportTemplate?.availableFilters;
  const activeFilters = useRecoilValue(reportFiltersWithValuesAF(reportId));

  const { searchValue, isError, onChange, onSearchApply } =
    useReportFilterSearch();

  return (
    <>
      <FilterSearch
        searchValue={searchValue}
        onSearchApply={onSearchApply}
        onChange={onChange}
        isError={isError}
        applySearchTimeout={APPLY_SEARCH_TIMEOUT}
      />
      {Object.entries(activeFilters || {})?.map(
        ([templateKey, filterValues]) => {
          const { dropdownSource, selectItemsSource, filterFieldTypeId } =
            templateFilters?.[templateKey] || {};
          return dropdownSource || selectItemsSource ? (
            <FilterMultiSelectReports
              key={templateKey}
              templateKey={templateKey}
              dropdownSource={dropdownSource}
              selectItemsSource={selectItemsSource}
              initialCheckedValues={filterValues}
            />
          ) : (
            Boolean(filterFieldTypeId) && (
              <FiltersByIdsReport
                key={templateKey}
                templateKey={templateKey}
                initialCheckedValues={filterValues}
                filterFieldTypeId={filterFieldTypeId}
              />
            )
          );
        },
      )}

      {Actions}
    </>
  );
};
